import { render, staticRenderFns } from "./AutomatorTextEditor.vue?vue&type=template&id=4b7848e4"
import script from "./AutomatorTextEditor.vue?vue&type=script&lang=js"
export * from "./AutomatorTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports